import { render } from "./Fp_gallery.vue?vue&type=template&id=d9289c66&scoped=true"
import script from "./Fp_gallery.vue?vue&type=script&lang=js"
export * from "./Fp_gallery.vue?vue&type=script&lang=js"

import "./Fp_gallery.vue?vue&type=style&index=0&id=d9289c66&scoped=true&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\vue\\portfolio-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9289c66"]])

export default __exports__